<template>
  <div>
    <div class>
      <Steps :active="0"
             :stepsShow=true
             align-center>
        <Step :title="$t('offering.offbase')" @click.native="on_click('offbaseAdd')" />
        <Step :title="$t('offering.offeringResources')" @click.native="on_click('offeringResourcesAdd')" />
        <Step :title="$t('offering.offconditionAdd')" @click.native="on_click('offconditionAdd')" />
        <Step :title="$t('offering.offnoticeAdd')" @click.native="on_click('offnoticeAdd')" />
        <Step :title="$t('offering.offpriceAdd')" @click.native="on_click('offpriceAdd')" />
        <Step :title="$t('offering.offinvestAdd')" @click.native="on_click('offinvestAdd')" />
        <Step :title="$t('offering.offabilityAdd')"  @click.native="on_click('offabilityAdd')" />
      </Steps>
    </div>
    <br />
    <div class="divMessage">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ changeMessage }}</div>
    <br />
    <el-card class="aui-card--fill"
             shadow="never">
      <el-form label-position="top"
               label-width="145px"
               :model="dataForm"
               :rules="dataRule"
               ref="dataForm">
        <!-- row -->
        <!-- 排期编号 系统自动生成 -->
        <el-row>
          <el-col :span="6">
            <el-form-item :label="$t('offering.offeringNo')"
                          prop="offeringNo">
              <el-input v-model="dataForm.offeringNo"
                        placeholder=" "
                        disabled></el-input>
            </el-form-item>
          </el-col>
          <!-- 排期名称 -->
          <el-col :span="6">
            <el-form-item :label="$t('offering.offringname')"
                          prop="offeringName">
              <el-input v-model="dataForm.offeringName"
                        placeholder=" "
                        disabled></el-input>
            </el-form-item>
          </el-col>
          <!-- <template v-if=" this.dataForm.offeringId === '' || this.dataForm.offeringId === null"> -->
          <!-- 选择课程 select v-model="dataForm.selectCourse" 值是课程编号 -->
          <!-- <el-col :span="6"> -->
          <!-- <el-form-item :label="$t('offering.selectCourse')">
                <el-input placeholder=" "></el-input>
              </el-form-item> -->
          <!-- <el-form-item>
                <span slot="label">
                  <el-popover placement="bottom"
                              width="800"
                              trigger="click">
                    <el-link slot="reference">选择课程</el-link>
                    <offeringCourseds></offeringCourseds>
                  </el-popover>
                </span>
                <el-input style="width: 180px;"
                          v-model="dataForm.offeringNo"
                          disabled></el-input>
              </el-form-item>
            </el-col>
          </template> -->
          <!-- <template v-else> -->
          <el-col :span="6">
            <el-form-item :label="$t('offering.selectCourse')"
                          prop="courseId">
              <el-input placeholder=" "
                        v-model="dataForm.courseCode"
                        disabled></el-input>
            </el-form-item>
          </el-col>
          <!-- </template> -->
          <!-- 标准时长（天）自动带入 tofix  -->
          <el-col :span="6">
            <el-form-item :label="$t('offering.courseDays')"
                          prop="courseDays">
                          <span slot="label">{{$t('offering.courseDays')}}
                            <el-tooltip placement="bottom-start" effect="light" >
                              <div slot="content">
                                <p>1.需要与排期的开始时间、结束时间所选择的时长一致</p>
                                <p>2.若排期设置为补填培训记录时，天数请写0</p>
                              </div>
                              <em class="el-icon-question" style="color: #1C69D3"></em>
                            </el-tooltip>
                          </span>
<!--              <span>{{$t('offering.courseDays')}}</span>-->
<!--              <el-tooltip placement="top-start" effect="light" >-->
<!--                <div slot="content">{{ $t('course.titletian') }}</div>-->
<!--                <em class="el-icon-question"></em>-->
<!--              </el-tooltip>    -->
                <el-input v-model="dataForm.courseDays"
                        maxlength="9"
                        oninput="value=value.replace(/[^\d.]/g,'')"
                        disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- row -->
        <el-row>
          <!-- 课程中文名称 自动带入 -->
          <el-col :span="6">
            <el-form-item :label="$t('course.courseNameCn')"
                          prop="courseNameCn">
              <el-input v-model="dataForm.courseNameCn"
                        disabled></el-input>
            </el-form-item>
          </el-col>
          <!-- 课程英文名称 自动带入 -->
          <el-col :span="6">
            <el-form-item :label="$t('course.courseNameEn')"
                          prop="courseNameEn">
              <el-input v-model="dataForm.courseNameEn"
                        disabled></el-input>
            </el-form-item>
          </el-col>
          <!-- 最大人数 自动带入 -->
          <el-col :span="6">
            <el-form-item :label="$t('course.maxNumber')"
                          prop="maxNumber">
              <el-input v-model.number="dataForm.maxNumber"
                        :maxlength="9"
                        oninput="value=value.replace(/[^\d.]/g,'')"
                        disabled></el-input>
            </el-form-item>
          </el-col>
          <!-- 最小人数 自动带入 -->
          <el-col :span="6">
            <el-form-item :label="$t('course.minNumber')"
                          prop="minNumber">
              <el-input v-model.number="dataForm.minNumber"
                        placeholder=" "
                        :maxlength="9"
                        oninput="value=value.replace(/[^\d.]/g,'')"
                        disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- row -->
        <!-- 开始时间 默认早上9点 YYYY-MM-DD HH:mm -->
        <el-row>
          <el-col :span="6">
            <el-form-item :label="$t('offering.startdate')"
                          prop="startdate">
              <el-date-picker v-model="dataForm.startdate"
                              value-format="yyyy-MM-dd HH:mm"
                              format="yyyy-MM-dd HH:mm"
                              type="datetime"
                              placeholder="选择日期时间"
                              disabled></el-date-picker>
            </el-form-item>
          </el-col>
          <!-- 结束时间 默认晚上5点 YYYY-MM-DD HH:mm -->
          <el-col :span="6">
            <el-form-item :label="$t('offering.enddate')"
                          prop="enddate">
              <el-date-picker v-model="dataForm.enddate"
                              value-format="yyyy-MM-dd HH:mm"
                              format="yyyy-MM-dd HH:mm"
                              type="datetime"
                              placeholder="选择日期时间"
                              disabled></el-date-picker>
            </el-form-item>
          </el-col>
          <!-- 是否设置及格分数线 自动带入 默认 否20 -->
          <el-col :span="6">
            <el-form-item :label="$t('course.passMarkFlag')"
                          prop="passMarkFlag">
              <el-select v-model="dataForm.passMarkFlag"
                         :placeholder="$t('course.select')"
                         disabled>
                <el-option v-for="(item,index) in courseBooleanArr"
                           :key="index"
                           :label="item.name"
                           :value="item.code"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 及格分数  自动带入 tofix -->
          <el-col :span="6">
            <div v-if="this.dataForm.passMarkFlag=='10'">
              <el-form-item :label="$t('course.passMarkScore')"
                            prop="passMarkScore">
                <el-input v-model="dataForm.passMarkScore"
                          maxlength="10"
                          oninput="value=value.replace(/[^\d.]/g,'')"
                          disabled></el-input>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
        <!-- 备注 -->
        <el-row>
          <el-col :span="24">
            <el-form-item :label="$t('offering.offeringRemark')"
                          prop="offeringRemark">
              <el-input v-model="dataForm.offeringRemark"
                        type="textarea"
                        disabled
                        :maxlength="2000"
                        show-word-limit></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <div>
      <el-row style="float:right; margin-bottom: 60px;">
        <el-col :span="16">
          <div class="grid-content" />
        </el-col>
        <el-button @click="sendEdit" v-if= initIsShowEdit
                   type="primary">{{ $t("course.edit") }}</el-button>
        <el-button @click="btnSaveNextStep"
                   type="primary">{{ $t("course.next") }}</el-button>
      </el-row>
    </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
// 基本信息   offbaseAdd
// 报名条件   offconditionAdd
// 报名通知   offnoticeAdd
// 价格相关   offpriceAdd
// 调查问卷   offinvestAdd
// 能力项设置 offabilityAdd

import Steps from '../../common/steps/index'
import Step from '../../common/steps/src/step'
import offeringCourseds from '../offeringcommon/offeringCoursed'

export default {
  // import引入的组件需要注入到对象中才能使用
  components: { Steps, Step, offeringCourseds },
  props: ['message', 'passOfferingId', 'isShowEdit'],
  inject: ['toTop'],
  data () {
    return {
      showEdit:this.isShowEdit,
      initIsShowEdit:'',
      changeMessage: this.message,
      courseBooleanArr: this.enums['CouresYesNoFlag'],
      dataForm: {
        isTencentSite:false,
        offeringId: '',
        offeringNo: '',
        offeringName: '',
        offeringStatus: '',
        courseId: '',
        maxNumber: '',
        minNumber: '',
        courseNameCn: '',
        courseNameEn: '',
        courseDays: '',
        courseCode: '',
        passMarkFlag: '20',
        passMarkScore: '',
        startdate: '',
        enddate: '',
        offeringRemark: '',
        siteName: '',
        siteNameAndClassnameAndType: '',
        courseTeamCatalogSecond:''
      }
    }
  },
  // 监听属性 类似于data概念
  computed: {
    dataRule () {
      return {
        maxNumber: [{ required: true, message: this.$t('course.plsin') + this.$t('course.maxNumber'), trigger: 'blur' }],
        minNumber: [{ required: true, message: this.$t('course.plsin') + this.$t('course.minNumber'), trigger: 'blur' }],
        courseNameCn: [{ required: true, message: this.$t('course.plsin') + this.$t('course.courseNameCn'), trigger: 'blur' }],
        courseNameEn: [{ required: true, message: this.$t('course.plsin') + this.$t('course.courseNameEn'), trigger: 'blur' }],
        passMarkFlag: [{ required: true, message: this.$t('course.plsin') + this.$t('course.passMarkFlag'), trigger: 'change' }],
        startdate: [{ required: true, message: this.$t('course.plsin') + this.$t('offering.startdate'), trigger: 'blur' }],
        enddate: [{ required: true, message: this.$t('course.plsin') + this.$t('offering.enddate'), trigger: 'blur' }],
        courseDays: [{ required: true, message: this.$t('course.plsin') + this.$t('course.courseDays'), trigger: 'blur' }],
        passMarkScore: [{ required: true, message: this.$t('course.plsin') + this.$t('course.passMarkScore'), trigger: 'blur' }],
        // offeringNo: [{ required: true, message: this.$t('course.plsin') + this.$t('offering.offeringNo'), trigger: 'blur' }],
        // offeringName: [{ required: true, message: this.$t('course.plsin') + this.$t('offering.offringname'), trigger: 'blur' }],
        courseId: [{ required: true, message: this.$t('course.plsin') + this.$t('offering.selectCourse'), trigger: 'blur' }]
      }
    }
  },
  // 监控data中的数据变化
  watch: {
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {
    // console.log("offeringBaseInfoShow")
    // console.log(this.showEdit)
    // console.log(this.isShowEdit)
    // this.showEdit = this.isShowEdit
    // console.log(this.showEdit)
    this.dataForm.offeringId = this.$route.query.offeringId
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {
    console.log('mounted')
  },
  beforeCreate () {
    console.log('beforeCreate')
  }, // 生命周期 - 创建之前
  beforeMount () {
    console.log('beforeMount')
  }, // 生命周期 - 挂载之前
  beforeUpdate () {
    console.log('beforeUpdate')
  }, // 生命周期 - 更新之前
  updated () {
    console.log('updated')
  }, // 生命周期 - 更新之后
  beforeDestroy () {
    console.log('beforeDestroy')
  }, // 生命周期 - 销毁之前
  destroyed () {
    console.log('destroyed')
  }, // 生命周期 - 销毁完成
  activated () {
    if (this.$route.query.offeringId !== undefined && this.$route.query.offeringId !== '') {
      // #TODO 再次进入页面初始化数据
      console.log('再次进入 offeringBaseInfo')
      console.log(this.$route.query.offeringId)
      this.init(this.$route.query.offeringId)
    }

    if (this.$route.query.isShowEdit !== undefined && this.$route.query.isShowEdit !== '') {
      this.initIsShowEdit = this.$route.query.isShowEdit
    }

    if (this.$route.query.courseId !== undefined && this.$route.query.courseId !== '') {
      // #TODO 再次进入页面初始化数据
      console.log('创建完成课程进入排期')
      console.log(this.$route.query.courseId)
      this.initCourse(this.$route.query.courseId)
    }
  },
  // 方法集合
  methods: {
    // 设置初始化为空
    again () {
      this.dataForm.offeringId = ''
      this.dataForm.offeringNo = ''
      this.dataForm.offeringName = ''
      this.dataForm.offeringStatus = ''
      this.dataForm.courseId = ''
      this.dataForm.maxNumber = ''
      this.dataForm.minNumber = ''
      this.dataForm.courseNameCn = ''
      this.dataForm.courseNameEn = ''
      this.dataForm.courseDays = ''
      this.dataForm.courseCode = ''
      this.dataForm.passMarkFlag = '20'
      this.dataForm.passMarkScore = ''
      this.dataForm.startdate = ''
      this.dataForm.enddate = ''
      this.dataForm.offeringRemark = ''
    },
    // 初始化数据
    init (offeringId) {
      this.again()
      this.getOfferingBaseInfo()
    },
    btnSaveNextStep () {
      this.sendMsg()
    },
    // 向父页面传递消息 跳转下一页面
    sendMsg () {
      this.toTop()
      this.$emit('onShowModer', 'offeringResourcessend')
      this.getOfferingMsg()
    },
    // 向父页面传递消息 保存页面
    sendSave () {
      this.$emit('onShowModer', 'offconditionSave')
      this.getOfferingMsg()
    },
    // 点击导航跳转页面
    on_click (e) {
      console.log(this.dataForm.offeringId)
      console.log(this.isbasicinfo)
      console.log(this.dataIsbasicinfo)
      if ((this.dataForm.offeringId !== '' && this.dataForm.offeringId !== undefined) || this.isbasicinfo || this.dataIsbasicinfo) {
        this.$emit('onShowModer', e)
        this.$emit('onOfferingMsg', '课程名称:' + this.dataForm.courseNameCn + '，开始时间-结束时间:' + this.dataForm.startdate + ' - ' + this.dataForm.enddate + '，场地:' + this.dataForm.siteNameAndClassnameAndType)
        this.$emit('onOfferingId', this.dataForm.offeringId)
      }
    },
    // 获取排期信息
    getOfferingMsg () {
      this.$emit('onOfferingMsg', '课程名称:' + this.dataForm.courseNameCn + '，开始时间-结束时间:' + this.dataForm.startdate + ' - ' + this.dataForm.enddate + '，场地:' + this.dataForm.siteNameAndClassnameAndType)
      this.$emit('onOfferingId', this.dataForm.offeringId)
    },
    getOfferingBaseInfo () {
      this.dataForm.offeringId = this.$route.query.offeringId
      if (this.dataForm.offeringId === null || this.dataForm.offeringId === '') {
        return
      }
      this.$request.get('/learning/base/offeringinfo/getBaseInfo/' + this.dataForm.offeringId
      ).then((res, total, code, data) => {
        this.dataForm = data.data
                    console.log(res.isTencentSite)
                    if(res.isTencentSite === "1"){
                      this.isTencentSite = true
                    }
                    if(res.isTencentSite === "0"){
                      this.isTencentSite = false
                    }
                    console.log(res.isTencentSite+"666666666666666666666===========")
        if(this.isTencentSite == true){
          this.dataForm.siteNameAndClassnameAndType = data.data.siteName
        }else if(this.isTencentSite == false){
        this.dataForm.siteNameAndClassnameAndType = data.data.siteName
        if (data.data.siteClassNameCn) {
          this.dataForm.siteNameAndClassnameAndType = this.dataForm.siteNameAndClassnameAndType + ',' + data.data.siteClassNameCn
        }
        if (data.data.cityName) {
          this.dataForm.siteNameAndClassnameAndType = this.dataForm.siteNameAndClassnameAndType + ',' + data.data.cityName
        }
        }
        if (this.message === undefined || this.message === '') {
          this.changeMessage = '课程名称:' + this.dataForm.courseNameCn + '，开始时间-结束时间:' +this.dataForm.startdate + ' - ' + this.dataForm.enddate + '，场地:' + this.dataForm.siteNameAndClassnameAndType
        }

        // this.initIsShowEdit = this.checkEditRole()

      }).catch((err) => {
        console.log(err)
      })
    },
    // 格式化
    formatDate (startdate) {
      let startdataMM = new Date(startdate.replace(/-/g,"/"))
      let year = startdataMM.getFullYear()
      let month = startdataMM.getMonth() + 1
      if (month < 10) {
        month = '0' + month
      }
      let date = startdataMM.getDate()
      if (date < 10) {
        date = '0' + date
      }
      let hours = startdataMM.getHours()
      if (hours < 10) {
        hours = '0' + hours
      }
      let minutes = startdataMM.getMinutes()
      if (minutes < 10) {
        minutes = '0' + minutes
      }

      let startdatadd = year + '-' + month + '-' + date + ' ' + hours + ':' + minutes
      return startdatadd
    },
    // 取消按钮
    btnCancel () {
      this.$confirm('离开本页将不保存当前正在编辑的数据, 确定离开? ', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.tabRemove()
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 删除当前页面
    tabRemove () {
      let tabName = this.$store.state.contentTabsActiveName
      if (tabName === 'home') {
        return false
      }
      this.$store.state.contentTabs = this.$store.state.contentTabs.filter(
        item => item.name !== tabName
      )
      if (this.$store.state.contentTabs.length <= 0) {
        this.$store.state.sidebarMenuActiveName = this.$store.state.contentTabsActiveName =
          'home'
        return false
      }
      // 当前选中tab被删除
      if (tabName === this.$store.state.contentTabsActiveName) {
        this.$router.push({ name: this.$store.state.contentTabs[this.$store.state.contentTabs.length - 1].name })
      }
    },
    sendEdit(){
      console.log("sendEdit")
      this.$router.push({ path: 'learning-offering-offeringEdit', query: { offeringId: this.dataForm.offeringId } })
    },
    checkEditRole () {

      console.log("checkEditRole")

      if (this.dataForm.offeringStatus === '30' || this.dataForm.offeringStatus === '40') {
        return false
      }
      if (this.$hasPermission('learning:offering:offeringEdit')) {
        return true
      }
      if (this.$hasPermission('TEAM:' + this.dataForm.courseTeamCatalogSecond)) {
        return true
      }
      if (this.$hasPermission('learning:offering:editselfcreated')) {
        return true
      }
      return false
    },
    isShowEditButton(){
      console.log("isShowEditButton")
      console.log(this.showEdit)
      if(this.showEdit === true || this.showEdit === "true"){
        return true
      }else {
        return false
      }
    }
  }
}
</script>
<style lang='scss' scoped>
// @import url(); 引入公共css类
.el-textarea {
  width: 120%;
}
.grid-content {
  border-radius: 4px;
  min-height: 20px;
}
.el-date-editor.el-input {
  width: 100%;
}
</style>
